import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=703a85ec&"
import script from "./Wallet.vue?vue&type=script&lang=js&"
export * from "./Wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703a85ec')) {
      api.createRecord('703a85ec', component.options)
    } else {
      api.reload('703a85ec', component.options)
    }
    module.hot.accept("./Wallet.vue?vue&type=template&id=703a85ec&", function () {
      api.rerender('703a85ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Wallet.vue"
export default component.exports